import { notify } from 'messages';
import store from 'redux/store';
import { showDialog } from 'dialogs';
import EditRole from '../editRole';

export type ShowEditRoleArgs = { readonly mode: 'create' } | { readonly mode: 'edit'; readonly id: number };

/**
 * Open the role create / edit dialog. Drives the existing EditRole component
 * externally (hideTrigger + forceShow + onRequestClose); for edit it resolves
 * the role id to the store index EditRole addresses by.
 */
export const showEditRole = (args: ShowEditRoleArgs): void => {
  if (args.mode === 'create') {
    showDialog((close) => <EditRole newRole hideTrigger forceShow onRequestClose={close} />);
    return;
  }
  // EditRole addresses the record by store-list index. A not-found id would
  // resolve to undefined -> a blank editor that saves to an undefined role_id,
  // so bail rather than open it (the row is stale; the list needs a refresh).
  const stateId = store.getState().roles.roles.findIndex((role: any) => role.role_id === args.id);
  if (stateId < 0) {
    notify.error('Role not found; the UI may be out of date. Please refresh.');
    return;
  }
  showDialog((close) => <EditRole stateId={stateId} hideTrigger forceShow onRequestClose={close} />);
};
